import Geolocation from './components/geolocation';
import './components/slider';

window.addEventListener('DOMContentLoaded', function() {

    // login page
    document.querySelectorAll('input[type="email"]').forEach(emailInput => {
        emailInput.addEventListener('blur', function(event) {
            event.target.value = event.target.value.trim().toLowerCase();
        });
    });

    document.querySelectorAll('#field-zipcode').forEach(zipcodeInput => {
        zipcodeInput.addEventListener('blur', event => {
            event.target.value = event.target.value.trim();
        });
    });

    // Get API Url from body
    let apiurl = document.body.getAttribute('data-apiurl');
    if (apiurl === null || apiurl === '') {
        console.warn('NO API URL SET, USING DEFAULT DEFINED IN JS! Fix this and define an API Url!');
        apiurl = 'https://api.userservice.cloud/';
    }

    // Init components
    new Geolocation({
        'apiurl': apiurl
    });

    // Public download page
    document.querySelectorAll('form[data=public-download]').forEach(pdownload => {
        pdownload.addEventListener('submit', function(event) {
            event.target.style.display = 'none';
            document.querySelector('div.u-in-progess').classList.removeClass('u-hide');
        });
    });

    document.querySelectorAll('.c-field__input + .c-field__unmask').forEach(unmask => {
        unmask.addEventListener('click', function(event) {
            let fieldPassword = event.target.closest('button').previousElementSibling;

            if (fieldPassword.getAttribute('type') == 'password') {
                fieldPassword.nextElementSibling.classList.add('c-field__open-eye');
                changeType(fieldPassword, 'text');
            }
            else {
                fieldPassword.nextElementSibling.classList.remove('c-field__open-eye');
                changeType(fieldPassword, 'password');
            }

            fieldPassword.focus();
            return false;
        });
    });

    function changeType(input, type) {
        try {
            return input.setAttribute('type', type); //Stupid IE security will not allow this
        } catch(e) {
            //Try re-creating the element (yep... this sucks)
            var newObject = document.createElement('input');
            newObject.type = type;
            if(input.size) newObject.size = input.size;
            if(input.value) newObject.value = input.value;
            if(input.name) newObject.name = input.name;
            if(input.id) newObject.id = input.id;
            if(input.className) newObject.className = input.className;
            input.parentNode.replaceChild(newObject,input);
            return newObject;
        }
    }
});
